import { render, staticRenderFns } from "./TopTenNovelList.vue?vue&type=template&id=a5188714&"
import script from "./TopTenNovelList.vue?vue&type=script&lang=js&"
export * from "./TopTenNovelList.vue?vue&type=script&lang=js&"
import style0 from "./TopTenNovelList.vue?vue&type=style&index=0&id=a5188714&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports